import { Link } from 'react-router-dom';
import { SEO } from '@/components/SEO';

export function TermsPage() {
  return (
    <article className="max-w-3xl mx-auto px-4 pt-12 pb-20 sm:pt-16 aces-prose">
      <SEO
        title="Terms of Use — ACES"
        description="Plain-English terms for using the ACES interactive commerce learning site."
        canonical="https://acescommerce.com/terms/"
      />
      <h1>Terms of Use</h1>
      <p><em>Last updated: 5 June 2026</em></p>

      <h2>Using ACES</h2>
      <p>
        ACES is free for personal, non-commercial educational use. Read, click, post journal entries, use the
        interactive simulations, share results with friends. None of this needs an account.
      </p>

      <h2>What you may do</h2>
      <ul>
        <li>Use ACES for your own learning, exam preparation, and revision.</li>
        <li>Share specific page URLs with classmates, teachers, or on social media.</li>
        <li>Quote short passages with attribution to ACES and a link back.</li>
      </ul>

      <h2>What you may not do</h2>
      <ul>
        <li>Republish substantial portions of ACES content (chapter narratives, worked examples, practice questions, hints) on another site without permission.</li>
        <li>Scrape ACES at scale to build a competing product or to train a model. Reasonable use by a search-engine crawler is fine.</li>
        <li>Misrepresent ACES as being affiliated with CBSE, NCERT, the Government of Kerala, or any school board. We are independent — see our{' '}<Link to="/about/" className="text-accent-600 underline">About page</Link>.</li>
        <li>Attempt to bypass advertising, deface, or interfere with the operation of the site.</li>
      </ul>

      <h2>Content accuracy</h2>
      <p>
        We aim for accuracy and surface verification status openly (the &ldquo;Under review&rdquo; badge means
        an editor flagged something). However, ACES is an educational supplement, not a substitute for a
        qualified teacher or for the official prescribed textbook. <strong>For board examinations, always
        cross-check with your prescribed textbook and your teacher.</strong>
      </p>

      <h2>No warranty</h2>
      <p>
        ACES is provided &ldquo;as is&rdquo; without warranties of fitness for a particular purpose. We make no
        guarantee that ACES will help you score a specific mark or pass a specific examination. Use it as one
        learning aid among several.
      </p>

      <h2>Liability</h2>
      <p>
        To the maximum extent permitted by law, ACES, its operators, and contributors are not liable for any
        loss arising from your use of the site — including missed examinations, wrong answers, or incorrect
        career decisions. You bear responsibility for the choices you make based on what you read here.
      </p>

      <h2>Intellectual property</h2>
      <p>
        All original ACES content (chapter narratives, worked examples, practice questions, simulations, design
        system, code) is © 2026 ACES. The CBSE NCERT and Kerala SCERT syllabi referenced throughout are public
        government curriculum specifications; chapter titles and concept lists follow them. Official textbooks and
        question papers are copyrighted by their publishers and are not reproduced on ACES.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms. Substantive changes will be flagged at the top of this page with a new
        &ldquo;Last updated&rdquo; date.
      </p>

      <h2>Jurisdiction</h2>
      <p>
        These terms are governed by the laws of India. Disputes will be resolved in the appropriate courts in
        Kerala, India.
      </p>
    </article>
  );
}
